export const NOTESADD_REQUEST = "NOTESADD_REQUEST";
export const NOTESADD_SUCCESS = "NOTESADD_SUCCESS";
export const NOTESADD_FAILURE = "NOTESADD_FAILURE";